module.exports = __webpack_public_path__ + "img/sample-dashboard-chart.b03ad7fa.png";